import React from "react";
import { useAppSelector } from "../../../redux/store";
import HotelsTableHeader from "./HotelsTableHeader";

const HotelsTable = () => {
  const booking = useAppSelector((state) => state.booking);
  const hotels = booking.bookingHotels;

  return (
    <>
      {hotels && hotels.length > 0 && (
        <table className="table">
          <HotelsTableHeader />

          <tbody>
            {hotels.map((hotel, i: any) => (
              <tr key={i}>
                <td>{hotel.from}</td>
                <td>{hotel.until}</td>
                <td>{hotel.name}</td>
                <td>
                  {hotel.noOfServices}x {hotel.accommodation}
                </td>
                <td>{hotel.catering}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
};

export default HotelsTable;
